// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IRentalApiParams, IUpdateRental } from "models/interfaces";

export const getAllRentals = createAsyncThunk(
  "rental/getAllRentals",
  async (data: IRentalApiParams) => {
    try {
      const response = await REST.post(
        `/rental/get-all-rentals?${data.endDate && `endDate=${data.endDate}`}${
          data.lockerId && `&lockerId=${data.lockerId}`
        }${data.page && `&page=${data.page}`}&size=7${
          data.startDate && `&startDate=${data.startDate}`
        }`,
        data.userFullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getRentalDetails = createAsyncThunk(
  "rental/getRental",
  async (rentalId: number) => {
    try {
      const response = await REST.get(
        `/rental/get-rental-details?rentalId=${rentalId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getUserRentals = createAsyncThunk(
  "rental/getUserRentals",
  async (userId: number) => {
    try {
      const response = await REST.get(
        `/rental/get-user-rentals?userId=${userId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const updateRentalStatus = createAsyncThunk(
  "rental/updateRentalStatus",
  async (data: IUpdateRental) => {
    try {
      const response = await REST.get(
        `/rental/update-rental-status?rentalId=${data.id}&status=${data.status}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
